import React, {Component, useEffect, useState} from "react";
import Table from "rc-table";
import "rc-table/assets/index.css";
import _ from 'lodash'
import {Card, Checkbox} from "../appUtils";
import memoizeOne from 'memoize-one'
import Dropdown from 'rc-dropdown';
import 'rc-dropdown/assets/index.css';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import '../Pagination/index.css';
import faSearch from "./icons/search.svg"
import darkSearch from "./icons/darkSearch.svg"
import "./index.css";
import async from "async"
import moment from "moment";
import {withRouter} from "../../../withRouter.jsx";

const defaultPagination = {
    defaultPageSize: 100,
    pageSize: 100,
    pageSizeOptions: ['25', '50', '100', '200', '500'], position: 'bottom',
}

const ColumnsComponent = (props) => {
    let {
        filterFields,
        columns,
        onChange,
        onSubmit,
        initialColumns: initCal,
        extraProps,
        location,
        setTableSearch,
        extraActions
    } = props;
    let [state, setState] = useState({})
    const [initialized, setInitialized] = useState(false);
    let initialChecked = initCal && initCal.length ? columns.filter((col) => initCal.includes(col.key)) : columns;
    const [selectedColumns, setSelectedColumns] = useState(
        initialChecked.map((col) => col.key)
    );
    const handleCheckboxChange = (selected) => {
        setSelectedColumns(selected);
    };
    useEffect(() => {
        events.initState()
    }, [filterFields])


    useEffect(() => {
        handleFilter()
    }, [selectedColumns])

    let handleFilter = () => {
        let newColumns = columns.filter(col => selectedColumns.includes(col.key));
        onChange(newColumns);
    }

    let viewComponent = (
        <div className="dropdown" style={{float: "right"}}>
            <button
                className="btn btn-label-primary rounded-pill  dropdown-toggle hide-arrow btn-sm"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                    marginRight: 0,
                    padding: "4px 15px 2px 8px"
                }}>
                <div className="position-relative">
                    <i className={"menu-icon tf-icons bx bx-list-ul"}
                       style={{marginRight: "3px !important"}}/>
                    View
                    <span className="badge rounded-pill bg-danger border"/>
                </div>
            </button>
            <ul className="dropdown-menu dropdown-menu-end"
                aria-labelledby="dropdownMenuButton"
                style={{minWidth: 250, width: "auto", animation: "slide-up 0.3s"}}
                onClick={(e) => {
                    e.stopPropagation();
                }}>
                <div className="menuBox"
                     style={{padding: "10px", minWidth: 250, width: "auto"}}>
                    <Checkbox.Group
                        options={columns}
                        keyAccessor={x => x.title}
                        valueAccessor={x => x.key}
                        value={selectedColumns}
                        onChange={handleCheckboxChange}
                        className="custom-checkbox-group"
                    />
                </div>
            </ul>
            {extraActions}
        </div>
    )
    useEffect(() => {
        if (extraProps) {
            onSubmit(extraProps.filters);
        }
        events.initState1()
    }, [extraProps && (extraProps.filters)])

    const events = {
        initState1: () => {
            if (filterFields && filterFields.length) {
                let fieldKeys = {}
                _.each(filterFields, (item) => {
                    if (item.key === 'intakeId') {
                        fieldKeys[item.key] = item.value ? item.value : "";
                    }
                })
                setState((prevState) => {
                    return {
                        ...prevState,
                        ...fieldKeys
                    }
                })
            }
        },
        initState: () => {
            const params = new URLSearchParams(location.search);
            if (filterFields && filterFields.length) {
                let fieldKeys = {};
                _.each(filterFields, (item) => {
                    const queryColumns = params.get(item.key);

                    if (queryColumns) {
                        fieldKeys[item.key] = queryColumns
                    }
                });
                setState(prevState => ({

                    ...prevState,
                    ...fieldKeys
                }));
                setInitialized(true);
            }
        },

        initStateReset: () => {
            if (!filterFields || !filterFields.length) return;

            const clearedFilters = filterFields.map(item => ({
                ...item,
                value:
                    item.type === "date" || item.type === "select"
                        ? undefined
                        : ""
            }));
            const fieldKeys = {};
            clearedFilters.forEach(item => {
                fieldKeys[item.key] = item.value;
            });

            setState(prev => ({
                ...prev,
                ...fieldKeys
            }));
            return clearedFilters;
        },

        handleFilter: () => {
            let fieldKeys = {};
            async.forEachOf(state, (value, key, cb) => {
                if (value !== undefined && value !== '') {
                    fieldKeys[key] = value;
                }
                cb();
            }, () => {
                onSubmit(fieldKeys);
                setTableSearch(true)
            });
        },

        handleClear: async () => {
            if (filterFields?.length) {
                let fieldKeys = {};
                filterFields.forEach(item => {
                    fieldKeys[item.key] =
                        item.type === "date" ? null :
                            item.type === "select" ? undefined :
                                item.type === "text" ? "" :
                                    "";
                });

                setState(prev => ({
                    ...prev,
                    ...fieldKeys
                }));

                await events.initStateReset(filterFields)
                if (props.resetPagination) {
                    props.resetPagination();
                }
            }

            onSubmit({});
        },
        _updateState: (data) => {
            setState((prevState) => {
                return {
                    ...prevState,
                    ...data
                }
            })
        }
    }

    useEffect(() => {
        if (!initialized) return;

        let fieldKeys = {};
        _.each(state, (value, key) => {
            if (value !== undefined && value !== "") {
                fieldKeys[key] = value;
            }
        });

        onSubmit(fieldKeys);
    }, [initialized]);
    return (
        <>
            {viewComponent}

        </>
    );
};


class MenuCallback extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: ""
        }
    }

    setUpdateText = (target) => {
        let value = target && target.value ? target.value : null
        this.setState({searchText: value})
    }

    handleSearch = () => {
        let {searchText} = this.state;
        let {confirm, searchTextName, toggleMenu} = this.props;
        // confirm({[searchTextName]: searchText ? [searchText] : []})
        confirm(searchText, searchTextName)

        toggleMenu()

    }
    handleClear = () => {
        let {handleReset, searchTextName, toggleMenu} = this.props;
        this.setState({
            searchText: ""

        }, () => {
            handleReset(searchTextName)
            toggleMenu()
        })
    }

    render() {
        let {searchText} = this.state;
        return (
            <div className={'filterBtnGroup'}>
                <input type={'text'}
                       placeholder={'Search'}
                       autoFocus={true}
                       className={'searchInput'}
                       value={searchText}
                       onChange={e => this.setUpdateText(e.target)}
                />
                <button className={'btn btn-search'}
                        icon="search"
                        size="small"
                        style={{width: 90, marginRight: 8}}
                        onClick={() => this.handleSearch()}
                >
                    <img src={faSearch} className={'searchIcon'}/> {' '}
                    Search
                </button>
                <button
                    className={'btn btn-reset'}
                    onClick={() => {
                        this.handleClear()
                    }}
                    style={{width: 90}}>
                    Reset
                </button>
            </div>
        )
    }
}

const GetColumnSearchTitleProps = (props) => {
    let {title} = props;
    let [visible, setVisible] = useState(false)
    let toggleMenu = () => {
        setVisible(!visible);
    }
    return (
        <>
            {title}
            <Dropdown
                trigger={['click']}
                visible={visible}
                // onBlur={() => setVisible(false)}
                overlay={<MenuCallback {...props} toggleMenu={toggleMenu}/>}
                animation="slide-up"
                onVisibleChange={(visibleValue) => {
                    toggleMenu()
                }}>
                <button className={'searchBtn'}>
                    <img src={darkSearch} className={'searchIcon'}/>
                </button>
            </Dropdown>
        </>
    )
}

class TableMain extends Component {
    state = {
        data: [],
        size: 'small',
        columns: [],
        pagination: this.props.pagination || defaultPagination,
        loading: true,
        searchText: '',
        dataSearchParams: {},
        selectedKeys: {},
        refreshKey: moment(),
        fieldsUpdated: false,
        staticPagination: {}
    }

    constructor(props) {
        super(props)
        this.fetch2 = memoizeOne(this.fetch);
        this.setLocal2 = this.setLocal;
        this.getMemoColumns = memoizeOne(this.getMemoColumns);
        // this.tableRef = React.createRef()

    }

    fetch = async (params = {}) => {
        let cloneA = Object.assign(this.state.selectedKeys, {})
        this.setState({
            loading: true,
            dataSearchParams: params,
        })
        params.count = params.results || this.state.pagination.defaultPageSize
        let data = await this.props.apiRequest({...params, ...cloneA})
        let pagination = {...this.state.pagination}
        pagination.total = data.total;
        this.setState({
            loading: false,
            data: data.data,
            pagination,
            refreshKey: moment()
        })

    }
    setLocal = () => {
        this.setState({
            loading: false,
            data: this.props.dataSource,
        })
    }

    handleSearch = (selectedKeys, confirm) => {
        confirm()
        this.setState({searchText: selectedKeys[0]})
    }

    getMemoColumns = (columns) => {

        return [...columns].filter(Boolean);
    };

    reload = () => {
        if (!!this.props.apiRequest) {
            this.fetch(this.state.dataSearchParams);
        }
    }

    reloadOnPageChange = () => {
        this.setState({loading: true})
        if (!!this.props.apiRequest) {
            let {pagination} = this.state
            this.fetch({
                results: pagination.pageSize || pagination.defaultPageSize,
                page: pagination.current,
            })
        }
    }

    setDataState = async () => {


    }


    handleReset = (key) => {
        let {selectedKeys} = this.state;
        let cloneObj = Object.assign(selectedKeys, {})
        delete cloneObj[key];
        this.setState({selectedKeys: cloneObj}, () => {
            this.fetch()
        })
    }

    confirmFxn = (value, key) => {
        let {selectedKeys} = this.state;
        let cloneObj = Object.assign(selectedKeys, {})
        if (value) {
            cloneObj[key] = [value]
        } else {
            delete cloneObj[key]
        }
        this.setState({selectedKeys: cloneObj}, () => {
            this.fetch()
        })
    }

    componentDidMount() {
        this.setFieldsDefault()
    }

    setFieldsDefault = () => {
        let {pagination = defaultPagination, apiRequest} = this.props
        let x = []
        _.each(this.props.columns, (i) => {
            if (i.searchTextName) {
                i.placeHolder = `Search ${i.title}`
                i.title = <GetColumnSearchTitleProps
                    {...i}
                    confirm={this.confirmFxn}
                    handleReset={(value) => this.handleReset(value)}
                />
            }
            if (i.dataIndex === undefined && i.key !== 'actions' && i.type !== 'actions') {
                i.dataIndex = i.key
            }
            x.push(i)
        })

        this.setState({
            columns: x
        })

        if (!!apiRequest) {
            this.fetch2({
                results: pagination.defaultPageSize
            })
        } else {
            this.setLocal2()
        }
    }

    resetPagination = () => {
        const {pagination} = this.state;

        this.setState(
            {
                pagination: {
                    ...pagination,
                    current: 1,
                    pageSize: pagination.defaultPageSize
                }
            },
            () => {
                this.reloadOnPageChange();
            }
        );
    };

    renderDynamic() {

        const {columns, pagination, refreshKey, data} = this.state;
        let {
            ref = null,
            extraProps = {},

            showPagination = true,
            showSizeChanger = true,
            showSeries = true
        } = this.props;

        const safeExtraProps = {
            ...extraProps,
            scroll: data && data.length ? extraProps.scroll ? {...extraProps.scroll} : undefined : undefined,
        };

        let paginationBox = (
            <div>
                {showPagination ?
                    <div className={`pagination-box ${pagination.position}`}>
                        <Pagination
                            onChange={(item) => {
                                this.setState({
                                    pagination: {
                                        ...pagination,
                                        current: item
                                    }
                                }, () => {
                                    this.reloadOnPageChange()
                                })
                            }}
                            defaultPageSize={pagination.defaultPageSize}
                            pageSize={pagination.pageSize || pagination.defaultPageSize || 10}
                            current={pagination.current || 1}
                            showSizeChanger={showSizeChanger}
                            total={pagination.total}
                            sizeChangerRender={() => {
                                return (
                                    <>
                                        <select
                                            className={'page-size-selector'}
                                            value={pagination.pageSize}
                                            onChange={({target}) => {
                                                this.setState(
                                                    {
                                                        pagination: {
                                                            ...pagination,
                                                            current: 1,      // reset page
                                                            pageSize: target.value   // ✅ UPDATE SIZE
                                                        }
                                                    },
                                                    () => this.reloadOnPageChange()
                                                )
                                            }}>
                                            {pagination.pageSizeOptions.map((item) => {
                                                return (
                                                    <option key={item}>{item}</option>
                                                )
                                            })}
                                        </select>
                                    </>
                                )
                            }}
                        />
                    </div> : null}
            </div>
        )


        const memoColumns = this.getMemoColumns(
            columns,
            showSeries,
            pagination
        );

        return (
            <div style={{display: "grid", width: "100%", maxWidth: "100%", minWidth: 0, overflowX: "hidden"}}>
                <React.Fragment>
                    {pagination.position == "top" ? paginationBox : null}
                    <div className="card-datatable table-responsive" key={refreshKey}
                         style={{minWidth: 0, maxWidth: "100%", overflowX: "auto"}}>
                        <Table
                            {...safeExtraProps}
                            ref={ref}
                            bordered
                            emptyText={""}
                            className={'table text-start align-middle table-hover mb-0 data-table '}
                            columns={memoColumns}
                            rowKey={record => record._id}
                            data={this.state.data}
                        />
                    </div>
                    {pagination.position == "bottom" ? paginationBox : null}
                </React.Fragment>
            </div>
        )
    }

    renderStatic() {
        const {columns, staticPagination} = this.state;
        const {ref = null, extraProps = {}, dataSource} = this.props;
        const paginationDisabled = this.props.pagination === false;
        const showPagination = !paginationDisabled && this.props.showPagination !== false;
        const paginationConfig = this.props.pagination || {};
        const pagination = {
            ...defaultPagination,
            ...paginationConfig,
            pageSize: paginationConfig.pageSize || paginationConfig.defaultPageSize || defaultPagination.pageSize,
            current: paginationConfig.current || paginationConfig.defaultCurrent || 1,
            ...staticPagination
        };
        const source = Array.isArray(dataSource) ? dataSource : [];
        const pageSize = Number(pagination.pageSize || pagination.defaultPageSize) || defaultPagination.defaultPageSize;
        const pageSizeOptions = pagination.pageSizeOptions || defaultPagination.pageSizeOptions;
        const totalPages = Math.max(1, Math.ceil(source.length / pageSize));
        const current = Math.min(Math.max(Number(pagination.current) || 1, 1), totalPages);
        const pagedData = !showPagination
            ? source
            : source.slice((current - 1) * pageSize, current * pageSize);
        const safeExtraProps = {
            ...extraProps,
            scroll: pagedData.length ? extraProps.scroll ? {...extraProps.scroll} : undefined : undefined,
        };

        const updatePagination = (changes) => {
            this.setState(({staticPagination: currentPagination}) => ({
                staticPagination: {
                    ...currentPagination,
                    ...changes
                }
            }));
        };

        return (
            <div style={{display: "grid", width: "100%", maxWidth: "100%", minWidth: 0, overflowX: "hidden"}}>
                {showPagination && pagination.position === "top" && (
                    <div className={`pagination-box ${pagination.position}`}>
                        <Pagination
                            onChange={(page) => updatePagination({current: page})}
                            current={current}
                            pageSize={pageSize}
                            total={source.length}
                            showSizeChanger={this.props.showSizeChanger !== false}
                            sizeChangerRender={() => (
                                <select
                                    className={'page-size-selector'}
                                    value={pageSize}
                                    onChange={({target}) => updatePagination({
                                        current: 1,
                                        pageSize: Number(target.value)
                                    })}>
                                    {pageSizeOptions.map((item) => <option key={item} value={item}>{item}</option>)}
                                </select>
                            )}
                        />
                    </div>
                )}
                <div className="card-datatable table-responsive"
                     style={{minWidth: 0, maxWidth: "100%", overflowX: "auto"}}>
                    <Table
                        {...safeExtraProps}
                        ref={ref}
                        bordered
                        emptyText={""}
                        className={'table text-start align-middle table-hover mb-0 data-table'}
                        columns={columns}
                        data={pagedData}
                    />
                </div>
                {showPagination && pagination.position !== "top" && (
                    <div className={`pagination-box ${pagination.position || "bottom"}`}>
                        <Pagination
                            onChange={(page) => updatePagination({current: page})}
                            current={current}
                            pageSize={pageSize}
                            total={source.length}
                            showSizeChanger={this.props.showSizeChanger !== false}
                            sizeChangerRender={() => (
                                <select
                                    className={'page-size-selector'}
                                    value={pageSize}
                                    onChange={({target}) => updatePagination({
                                        current: 1,
                                        pageSize: Number(target.value)
                                    })}>
                                    {pageSizeOptions.map((item) => <option key={item} value={item}>{item}</option>)}
                                </select>
                            )}
                        />
                    </div>
                )}
            </div>
        )
    }

    render() {
        const {apiRequest} = this.props
        return (
            <React.Fragment>
                {!!apiRequest ? this.renderDynamic() : this.renderStatic()}
            </React.Fragment>
        )
    }
}

export default withRouter(TableMain);
TableMain.TableColumnsComponent = ColumnsComponent;
